/**
 * defa.collections.LogEntries
 * A Collection of LogEntry models.
 * @version 1.2.0
 */
import LogEntry from 'scripts/defa/log/model-log-entry';

const LogEntries = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	model: LogEntry,
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );

export default LogEntries;